import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Action, Actions, State, StateContext } from "@ngxs/store";
import { RequestState, createRequestAction } from "ngxs-requests-plugin";

import { environment } from "../../../../environments/environment";
import { AppConfigService } from "../../services/app-config.service";

import { RenamePreset, RenamePresetSuccess, RenamePresetFail,
         RemovePreset, RemovePresetSuccess, RemovePresetFail
} from "./preset.actions";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ExtractService } from "../../services/extract.service";
import { FilterService } from "../../services/filter.service";
import { VariablesService } from "../../services/variables.service";

 export interface PresetStateModel {
 }

@RequestState('renamePreset')
@Injectable()
export class RenamePresetRequestState {}

@RequestState('removePreset')
@Injectable()
export class RemovePresetRequestState {}

@State<PresetStateModel>({
    name: 'preset',
    defaults: {},
    })
@Injectable()
export class PresetState {
    constructor(
        private http: HttpClient,
        private _snackbar: MatSnackBar,
        private filterService: FilterService,
        private variablesService: VariablesService,
        private extractService: ExtractService,
        private appConfig: AppConfigService,
    ) {}
    
    // Rename
    @Action(RenamePreset)
    renamePreset({ dispatch }: StateContext<PresetStateModel>, { payload }: RenamePreset) {
        const { oldName, newName, presetType } = payload;
        const dbName = this.appConfig.dbName;
        const request =  this.http.patch(`${environment.api}user/presets/update`, { oldName, newName, presetType, dbName })

        return dispatch(
            createRequestAction({
                request,
                state: RenamePresetRequestState,
                successAction: RenamePresetSuccess,
                failAction: RenamePresetFail
            })
        );
    }

    @Action(RenamePresetSuccess)
    renamePresetSuccess({ dispatch }: StateContext<PresetStateModel>, { payload }: RenamePresetSuccess) {
        const { name, presetType } = payload;

        // Request update for the relevant preset list
        switch (presetType) {
            case 'filters':
                this.filterService.getFiltersPresetList();
                break;
            case 'firmIdList': 
                this.filterService.getFirmIdListPresetList();
                break;
            case 'query':
                this.extractService.getAllQueries()
                break;
            case 'variables':
                this.variablesService.getVariablesPresetList()
                break;
            default:
                console.error(`Unknown preset type: ${presetType}`);
                break;
        }       
    }

    @Action(RenamePresetFail)
    renamePresetFail(ctx: StateContext<PresetStateModel>, { payload }: RenamePresetFail) {
        this._snackbar.open(payload.error_message, 'OK', {duration: 2000});
    }


    // Remove
    @Action(RemovePreset)
    removePreset({ dispatch }: StateContext<PresetStateModel>, { payload }: RemovePreset) {
        const { name, presetType } = payload;
        const dbName = this.appConfig.dbName;
        const body = { name, presetType, dbName };
        const request =  this.http.delete(`${environment.api}user/presets/delete`, {body})

        return dispatch(
            createRequestAction({
                request,
                state: RemovePresetRequestState,
                successAction: RemovePresetSuccess,
                failAction: RemovePresetFail
            })
        );
    }

    @Action(RemovePresetSuccess)
    removePresetSuccess({ dispatch }: StateContext<PresetStateModel>, { payload }: RemovePresetSuccess) {
        // Parse
        const { name, presetType } = payload;
        
        // Request update for the relevant preset list
        switch (presetType) {
            case 'filters':
                this.filterService.getFiltersPresetList();
                break;
            case 'firmIdList': 
                this.filterService.getFirmIdListPresetList();
                break;
            case 'query':
                this.extractService.getAllQueries()
                break;
            case 'variables':
                this.variablesService.getVariablesPresetList()
                break;
            default:
                console.error(`Unknown preset type: ${presetType}`);
                break;
        }       
    }

    @Action(RemovePresetFail)
    removePresetFail(ctx: StateContext<PresetStateModel>, { payload }: RemovePresetFail) {
        this._snackbar.open(payload.error_message, 'OK', {duration: 2000});
    }
}
